import 'slick-carousel';

let _this =  {

	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
		productLine: $('.franli-block-production-line-slider'),
		labelSlider: $('.label-slider'),
		productCategoriesSlider: $('.product-categories-slider'),
		homeHeroSlider: $('.franli-block-home-hero__slider')
    },

    vars: {
	},

	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {

        this.$dom.productLine.slick({
			slidesToScroll: 1,
			slidesToShow: 1,
			infinite: true,
			autoplay: true,
			speed: 1500,
			pauseOnHover: true,
			arrows: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						autoplay: false
					}
				},
			],
			prevArrow: `<div class='arrow-container arrow-container--left'>
							<svg fill="#1e2f46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve" transform="rotate(-90)">
								<path d="M16.5,15.5l-6-7l-6,7" transform="translate(1.5, -1)"></path>
							<circle cx="12" cy="12" r="11" stroke="#929ba6" stroke-width="1" fill="none" />
							</svg>
						</div>`,
			nextArrow : `<div class='arrow-container arrow-container--right'>
							<svg fill="#1e2f46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve" transform="rotate(90)">
								<path d="M16.5,15.5l-6-7l-6,7" transform="translate(1.5, -1)"></path>
							<circle cx="12" cy="12" r="11" stroke="#929ba6" stroke-width="1" fill="none" />
							</svg>
						</div>`
		});

		this.$dom.labelSlider.slick({
			slidesToScroll: 1,
			slidesToShow: 6,
			infinite: true,
			variableWidth: true,
			arrows: true,
			prevArrow: `<div class='label-slider__icon--left'>
							<svg width="15" height="20" viewBox="-4.5 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" transform="rotate(180)">
							<g transform="translate(-425.000000, -6679.000000)" fill="#37688f">
							<g transform="translate(56.000000, 160.000000)">
							<path d="M370.39,6519 L369,6520.406 L377.261,6529.013 L376.38,6529.931 L376.385,6529.926 L369.045,6537.573 L370.414,6539 C372.443,6536.887 378.107,6530.986 380,6529.013 C378.594,6527.547 379.965,6528.976 370.39,6519" id="arrow_right-[#333]"> </path>
							</g>
							</g>
							</svg>
						</div>`,
			nextArrow : `<div class='label-slider__icon--right'>
							<svg width="15" height="20" viewBox="-4.5 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g transform="translate(-425.000000, -6679.000000)" fill="#37688f">
							<g transform="translate(56.000000, 160.000000)">
							<path d="M370.39,6519 L369,6520.406 L377.261,6529.013 L376.38,6529.931 L376.385,6529.926 L369.045,6537.573 L370.414,6539 C372.443,6536.887 378.107,6530.986 380,6529.013 C378.594,6527.547 379.965,6528.976 370.39,6519" id="arrow_right-[#333]"></path>
							</g>
							</g>
							</svg>
						</div>`
		});

		this.$dom.productCategoriesSlider.slick({
			slidesToScroll: 1,
			slidesToShow: 4,
			centerPadding: 100,
			autoplay: true,
			speed: 1500,
			pauseOnDotsHover: true,
			infinite: true,
			centerMode: false,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				  }
				},
				{
					breakpoint: 768,
					settings: {
					  slidesToShow: 1,
					  slidesToScroll: 1
					}
				},
			],
			prevArrow: `<div class='arrow-container arrow-container--left'>
							<svg fill="#1e2f46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve" transform="rotate(-90)">
								<path d="M16.5,15.5l-6-7l-6,7" transform="translate(1.5, -1)"></path>
							<circle cx="12" cy="12" r="11" stroke="#929ba6" stroke-width="1" fill="none" />
							</svg>
						</div>`,
			nextArrow : `<div class='arrow-container arrow-container--right'>
							<svg fill="#1e2f46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve" transform="rotate(90)">
								<path d="M16.5,15.5l-6-7l-6,7" transform="translate(1.5, -1)"></path>
							<circle cx="12" cy="12" r="11" stroke="#929ba6" stroke-width="1" fill="none" />
							</svg>
						</div>`
		});

		this.$dom.homeHeroSlider.slick({
			slidesToScroll: 1,
			slidesToShow: 1,
			infinite: true,
			autoplay: true,
			speed: 1000,
			pauseOnHover: true,
			arrows: false,
			dots:true
		});
    },

};

export default _this;